// export const BACKEND_URL = "http://localhost:3306";
export const BACKEND_URL = "https://invest-backend-smtx.onrender.com";